module.exports = __webpack_public_path__ + "static/media/R320.0c06e267.jpg";